module.exports = __webpack_public_path__ + "img/2.47130907.png";